<template>
  <el-footer class="ep-footer">
    <div class="container-responsive ep-footer__inner">
      <p class="ep-footer__copyright">&copy; 2025 114TK工具站. 所有权利保留.</p>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noreferrer"
         class="ep-footer__beian">
        <img src="/ba.png" alt="公安备案" class="ep-footer__beian-icon"/>
        <span>川公网安备51010602003086号</span>
      </a>
      <!--      <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noreferrer"-->
      <!--         class="ep-footer__beian">-->
      <!--        <img src="/ba.png" alt="公安备案" class="ep-footer__beian-icon"/>-->
      <!--        <span>川公网安备51010602003087号</span>-->
      <!--      </a>-->
      <a href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer"
         class="ep-footer__beian">
        <img src="/ba.png" alt="公安备案" class="ep-footer__beian-icon"/>
        <span>蜀ICP备2024102982号-4</span>
      </a>
      <div class="ep-footer__links">
        <a href="#" class="ep-footer__link">隐私政策</a>
        <a href="#" class="ep-footer__link">服务条款</a>
        <router-link to="/about" class="ep-footer__link">联系我们</router-link>
      </div>
    </div>
  </el-footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.ep-footer {
  margin-top: 32px;
  padding: 24px 0 calc(24px + var(--safe-area-bottom));
  background: var(--el-bg-color-overlay);
  border-top: 1px solid var(--el-border-color-lighter);
}

.ep-footer__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.ep-footer__copyright {
  color: var(--el-text-color-secondary);
  margin: 0;
}

.ep-footer__beian {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--el-text-color-secondary);
  transition: color 0.2s ease;
}

.ep-footer__beian:hover {
  color: var(--el-color-primary);
}

.ep-footer__beian-icon {
  width: 18px;
  height: 18px;
}

.ep-footer__links {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
}

.ep-footer__link {
  color: var(--el-text-color-regular);
  transition: color 0.2s ease;
}

.ep-footer__link:hover {
  color: var(--el-color-primary);
}

@media (min-width: 768px) {
  .ep-footer__inner {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
}
</style>
